import { FC } from "react";

import styled from "@emotion/styled";
import { IconArrowUpRight } from "src/ui/assets/icons/IconArrowUpRight";
import Translate from "src/ui/components/Translate/Translate";

import {
  AppPopup,
  AppQueryPopupsController
} from "../AppQueryPopups/AppQueryPopupsBloc";

const rxdietMeal =
  "https://cdn.sanity.io/images/g38rxyoc/production/7ea1de7ec391337ae6c6e69c19f0fb3d2bb7f951-480x480.webp";
const rxdietPattern =
  "https://cdn.sanity.io/images/g38rxyoc/production/c47a95b69ca22a88127163e6865e868a965edc53-981x420.webp";

const Card = styled.button`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
  margin: 0;
  border: none;
  text-align: left;
  cursor: pointer;
  padding: 1.5rem 6rem 1rem 1rem;
  border-radius: 0.5rem;
  overflow: hidden;
  background-color: var(--color-white, #fff);
  background-image: url(${rxdietPattern});
  background-size: cover;
  background-position: center right;
  box-shadow:
    -3px 2px 8px rgba(157, 41, 219, 0.08),
    -53px 26px 24px rgba(157, 41, 219, 0.01);
`;

const MealImage = styled.div`
  position: absolute;
  top: -1.8rem;
  right: -2.375rem;
  width: 8.25rem;
  height: 8.25rem;
  border-radius: 200px;
  background-image: url(${rxdietMeal});
  background-size: cover;
  background-position: center;
  box-shadow:
    -5px 5px 8px rgba(69, 49, 22, 0.08),
    -20px 20px 14.5px rgba(69, 49, 22, 0.07),
    -46px 45px 19.5px rgba(69, 49, 22, 0.03);
`;

const Header = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  color: #5f1f8f;
`;

const Title = styled.p`
  margin: 0;
  font-size: 1.125rem;
  font-weight: 500;
  line-height: 1.33;
  letter-spacing: -0.36px;
`;

const Description = styled.p`
  margin: 0;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.43;
  letter-spacing: -0.28px;
`;

const Cta = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 2px;
  color: #5f1f8f;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.4;
  letter-spacing: -0.28px;
`;

const RxDietCard: FC = () => {
  const openMealPlanning = (): void => {
    AppQueryPopupsController.openPopup(AppPopup.mealPlanning);
  };

  return (
    <Card type="button" onClick={openMealPlanning}>
      <MealImage aria-hidden="true" />
      <Header>
        <Title>
          <Translate msg="mealInsights.rxDiet.title" />
        </Title>
        <Description>
          <Translate msg="mealInsights.rxDiet.description" />
        </Description>
      </Header>
      <Cta>
        <Translate msg="mealInsights.rxDiet.cta" />
        <IconArrowUpRight />
      </Cta>
    </Card>
  );
};

export default RxDietCard;
